import React, { Component } from 'react'
import axios from 'axios'

import PropTypes from 'prop-types'
import loadable from '@loadable/component'
import SimpleSearchForm from './SimpleSearchForm/SimpleSearchForm'

import './SearchForm/SearchForm.less'

const SearchForm = loadable(() => import('./SearchForm/SearchForm'))

class SearchFormContainer extends Component {
  static propTypes = {
    searchFormPropsUrl: PropTypes.string,
    miniForm: PropTypes.bool,
  }

  state = {
    loaded: false,
    searchFormProps: {},
  }

  componentDidMount = () => {
    SearchForm.preload()
    // Dynamic importing of styles here prevents FOUC when the search form renders
    // import('./SearchForm/SearchForm.less')
    axios.get(this.props.searchFormPropsUrl).then(response => {
      this.setState({ loaded: true, searchFormProps: response.data })
    })
  }

  render() {
    return (
      <div>
        {this.state.loaded ? (
          <SearchForm
            {...this.state.searchFormProps}
            mini={this.props.miniForm}
            fallback={<SimpleSearchForm mini={this.props.miniForm} />}
          />
        ) : (
          <SimpleSearchForm mini={this.props.miniForm} />
        )}
      </div>
    )
  }
}

export default SearchFormContainer
